import React from 'react';
import { MessageCircle, Loader2 } from 'lucide-react';
import { AppStatusToggle } from './WhatsappConfigComponents';

const formatTimestamp = (ts) => {
    if (!ts) return 'N/A';
    try { return new Date(ts).toLocaleString(); } catch { return ts; }
};

export default function WhatsappConfigList({
    configs, isLoading,
    appNameStatuses, isLoadingAppStatuses,
    isUpdatingAppStatus, updatingAppName,
    selectedConfig,
    onSelect,
    onToggleAppStatus,
}) {
    return (
        <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 shadow-xl">
            <div className="flex items-center space-x-3 mb-6">
                <MessageCircle className="w-6 h-6 text-emerald-400" />
                <h3 className="text-xl font-semibold">WhatsApp Configurations</h3>
                <span className="px-3 py-1 bg-emerald-600/20 text-emerald-300 text-sm rounded-full">
                    {configs.length}
                </span>
            </div>

            {isLoading ? (
                <div className="flex items-center justify-center py-10">
                    <Loader2 className="w-7 h-7 animate-spin text-emerald-400" />
                    <span className="ml-3 text-white/70">Loading...</span>
                </div>
            ) : configs.length > 0 ? (
                <div className="space-y-4 max-h-[600px] overflow-y-auto custom-scrollbar pr-2">
                    {configs.map((config) => {
                        const appNameStatus = appNameStatuses[config.appName];
                        const isAppActive = appNameStatus === true || appNameStatus === 'true';
                        const isCurrentlyUpdating = updatingAppName === config.appName && isUpdatingAppStatus;

                        return (
                            <div
                                key={config._id}
                                onClick={() => onSelect(config)}
                                className={`p-5 rounded-xl border cursor-pointer transition-all duration-300 hover:scale-[1.02] shadow-sm hover:shadow-md ${selectedConfig?._id === config._id
                                    ? 'bg-emerald-600/20 border-emerald-500/50'
                                    : 'bg-white/5 border-white/10 hover:bg-white/10'
                                    }`}
                            >
                                {/* Header Row */}
                                <div className="flex items-center justify-between mb-2">
                                    <h4 className="font-semibold text-base">{config.appName}</h4>
                                    <div className={`flex items-center space-x-1 px-3 py-1 rounded-full text-sm ${config.STATUS === 'ACTIVE' ? 'bg-green-600/20 text-green-300' : 'bg-red-600/20 text-red-300'}`}>
                                        <div className={`w-2.5 h-2.5 rounded-full ${config.STATUS === 'ACTIVE' ? 'bg-green-400' : 'bg-red-400'}`} />
                                        <span>{config.STATUS}</span>
                                    </div>
                                </div>

                                <p className="text-sm text-white/60 mb-3">Vendor: {config.whatsapp_vendor_name}</p>

                                {/* App Name Status Toggle */}
                                <AppStatusToggle
                                    appName={config.appName}
                                    isActive={isAppActive}
                                    isLoading={isLoadingAppStatuses}
                                    isUpdating={isCurrentlyUpdating}
                                    onToggle={() => onToggleAppStatus(config.appName, isAppActive)}
                                />

                                <p className="text-sm text-white/60 mt-3">
                                    Created: {formatTimestamp(config.creation_time_str)}
                                </p>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div className="text-center py-10 text-white/60">
                    <MessageCircle className="w-14 h-14 mx-auto mb-3 opacity-50" />
                    <p>No WhatsApp configurations found</p>
                </div>
            )}

            <style jsx>{`
                .custom-scrollbar { scrollbar-width: thin; scrollbar-color: rgba(100,116,139,.4) rgba(51,65,85,.4); }
                .custom-scrollbar::-webkit-scrollbar { width: 8px; }
                .custom-scrollbar::-webkit-scrollbar-track { background: rgba(51,65,85,.4); border-radius: .5rem; }
                .custom-scrollbar::-webkit-scrollbar-thumb { background: rgba(100,116,139,.4); border-radius: .5rem; }
                .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: rgba(100,116,139,.6); }
            `}</style>
        </div>
    );
}